export default __webpack_public_path__ + "static/girl-bike-d98b2f5bc586878bcf74583f2dda972d.svg";